import { Box, Divider, Grid2, useMediaQuery, useTheme } from '@mui/material'
import { FC } from 'react'
import { useSelector } from 'react-redux'
import { WaterTestStripSelector } from '../../../../../store/waterTestStrip'
import { SignalCard } from './SignalCard'

export const ResultsBreakdown: FC = () => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))
  const groupedResults = useSelector(WaterTestStripSelector.makeWaterTestStripGroupedResults)
  const { Good = 0, Caution = 0, High = 0, Low = 0, NA = 0 } = groupedResults
  return (
    <Box
      sx={{
        backgroundColor: 'white',
        boxShadow: 'none',
        border: '1px solid #E2E8F0',
        borderRadius: '16px !important',
        '&:before': {
          display: 'none',
        },
      }}
    >
      <Grid2 container sx={{ py: '24px', px: '16px' }} columns={19} justifyContent="center">
        <Grid2 size={{ xs: 19, md: 4 }}>
          <SignalCard
            title="Safe"
            attributeCount={Good}
            description="This attribute is within the safe range for consumption."
            color={theme.palette.green[400]}
          />
        </Grid2>
        <Grid2
          sx={{
            flexShrink: 1,
            px: { sm: '2px', md: '4px' },
            py: { xs: '6px', md: '1px' },
          }}
          size={{ xs: 19, md: 1 }}
        >
          <Divider orientation={isMobile ? 'horizontal' : 'vertical'} />
        </Grid2>{' '}
        <Grid2 size={{ xs: 19, md: 4 }}>
          <SignalCard
            title="Caution"
            attributeCount={Caution}
            description="These attributes are safe but should be closely monitored"
            color={theme.palette.yellow[400]}
          />
        </Grid2>
        <Grid2
          sx={{
            flexShrink: 1,
            px: { sm: '2px', md: '4px' },
            py: { xs: '6px', md: '1px' },
          }}
          size={{ xs: 19, md: 1 }}
        >
          <Divider orientation={isMobile ? 'horizontal' : 'vertical'} />
        </Grid2>
        <Grid2 size={{ xs: 19, md: 4 }}>
          <SignalCard
            title="Unsafe"
            attributeCount={High + Low}
            description="This attribute is outside the safe range"
            color={theme.palette.red[400]}
          />
        </Grid2>
        <Grid2
          sx={{
            flexShrink: 1,
            px: { sm: '2px', md: '4px' },
            py: { xs: '6px', md: '1px' },
          }}
          size={{ xs: 19, md: 1 }}
        >
          <Divider orientation={isMobile ? 'horizontal' : 'vertical'} />
        </Grid2>
        <Grid2 size={{ xs: 19, md: 4 }}>
          <SignalCard
            title="Not Applicable"
            attributeCount={NA}
            description={`These Attributes have no "Out of range" value`}
            color={theme.palette.grey[200]}
          />
        </Grid2>
      </Grid2>
    </Box>
  )
}
